import { createAction } from '@reduxjs/toolkit';
import type { IssueCountResponse } from '@shared/schemas';

/**
 * The sidebar counts read by `GET /admin/profile-cleaning/issue-count`, shared
 * by two sibling slices that never import each other (#762): `profile-cleaning`
 * keeps `count`, the "Profile Cleaning" badge (#753), and
 * `exits-investments-review` keeps `exits_investments_to_complete`, the badge of
 * "Exit & Investment Review". The request itself stays in the Profile Cleaning
 * saga (one request, one cache on the server); both slices listen to these
 * transitions with `extraReducers`.
 */

/**
 * A read of the counts has just been sent. Lets a slice tell a response that
 * left before its own fresher figure (the queue's list landing meanwhile) from
 * one that left after it (#762). The read runs under `takeLatest`, so the next
 * `issueCountReceived` always answers the last `issueCountStarted`.
 */
export const issueCountStarted = createAction('profileIssueCount/started');

/** The counts read; a failed read dispatches nothing, so every slice keeps its last figures. */
export const issueCountReceived = createAction<IssueCountResponse['data']>(
  'profileIssueCount/received',
);
